import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { forwardRef } from 'react';
import {
  ReadOnly,
  SubSection,
  useEntityPermission,
  useFormPermissions,
  useLocalization,
} from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { Controller, useFormContext } from 'react-hook-form';
import { RECURRENCE_PATTERN } from '../../../../utils/constants';

const RecurrencePattern = forwardRef((props, ref) => {
  const { formatMessage } = useLocalization();
  const { control, getValues } = useFormContext();
  const { permissions } = useFormPermissions();
  const { isReadOnly } = useEntityPermission();
  const recurrencePattern = getValues(props?.name);
  const readOnly = isReadOnly(permissions[props?.name], recurrencePattern);
  return (
    <Box ref={ref}>
      <Controller
        control={control}
        name={props.name}
        render={({ field }) => {
          if (readOnly) {
            return (
              <ReadOnly>
                <FormattedMessage
                  id={field.value}
                  defaultMessage={
                    RECURRENCE_PATTERN(formatMessage).find(
                      p => p.value === field.value,
                    ).label
                  }
                />
                {props.recurrenceFrequencyValue === 'DAILY' ? '' : ', '}
              </ReadOnly>
            );
          }

          return (
            <RadioGroup row {...field}>
              {RECURRENCE_PATTERN(formatMessage).map(item => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio size="small" />}
                  label={item.label}
                />
              ))}
            </RadioGroup>
          );
        }}
      />
      {props.recurrenceFrequencyValue !== 'DAILY' && !readOnly && (
        <SubSection sx={{ mt: 1 }}>{props?.children}</SubSection>
      )}
      {readOnly && props?.children}
    </Box>
  );
});

export default RecurrencePattern;
